module.exports = __webpack_public_path__ + "media/images/back_1k-64cf6d8466a40fcdc299cd1c36b8011d.png";